import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineM } from '@sorare/core/src/atoms/typography';
import { Cards } from '@sorare/core/src/atoms/ui/Cards';
import { glossary } from '@sorare/core/src/lib/glossary';

const messages = defineMessages({
  title: {
    defaultMessage: 'No Cards found',
  },
  desc: {
    defaultMessage:
      'We couldn’t find any Card linked to your Ethereum account ({accountAddress}). Please make sure you have a Card to deposit and try again.',
  },
});

const Container = styled(Vertical).attrs({ gap: 2, center: true })`
  margin: 0 auto;
`;

type Props = {
  closeDialog: () => void;
  accountAddress?: string;
};

export const EmptyState = ({ closeDialog, accountAddress }: Props) => {
  return (
    <Container>
      <Cards />
      <HeadlineM as="h4">
        <FormattedMessage {...messages.title} />
      </HeadlineM>
      <BodyM className="text-center">
        <FormattedMessage {...messages.desc} values={{ accountAddress }} />
      </BodyM>
      <Button fullWidth size="medium" color="quaternary" onClick={closeDialog}>
        <FormattedMessage {...glossary.close} />
      </Button>
    </Container>
  );
};
